import { Check } from "lucide-react";
import { STAGES_POSITIVE, STAGES_TERMINAL_ALT, STAGE_COLORS } from "@/lib/constants";

interface Props {
  currentStage: string;
}

export function Stepper({ currentStage }: Props) {
  // Handle terminal alternative stages (Scaduta / Annullata)
  const isTerminal = (STAGES_TERMINAL_ALT as readonly string[]).includes(currentStage);

  if (isTerminal) {
    const colors = STAGE_COLORS[currentStage] ?? { bg: "bg-gray-100", text: "text-gray-800" };
    const label = currentStage === "Annullata" ? "Pratica annullata" : "Pratica scaduta";
    return (
      <div className={`${colors.bg} px-4 py-3 rounded-lg border border-border flex items-center gap-2`}>
        <span className={`text-sm font-medium ${colors.text}`}>{label}</span>
      </div>
    );
  }

  const stages = STAGES_POSITIVE as unknown as string[];
  const currentIndex = stages.indexOf(currentStage);

  return (
    <div className="bg-card p-4 rounded-lg border border-border">
      <div className="flex items-center justify-between">
        {stages.map((stage, i) => (
          <div key={stage} className="flex items-center flex-1">
            <div className="flex flex-col items-center flex-1">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
                  i < currentIndex
                    ? "bg-brand text-white"
                    : i === currentIndex
                    ? "bg-blue-500 text-white"
                    : "bg-border text-muted-foreground"
                }`}
              >
                {i < currentIndex ? <Check size={16} /> : i + 1}
              </div>
              <div
                className={`text-xs mt-1 font-medium ${
                  i < currentIndex
                    ? "text-brand"
                    : i === currentIndex
                    ? "text-blue-700"
                    : "text-muted-foreground"
                }`}
              >
                {stage}
              </div>
            </div>
            {i < stages.length - 1 && (
              <div
                className={`h-0.5 flex-1 mx-2 ${
                  i < currentIndex ? "bg-brand" : "bg-border"
                }`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
